import { type ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';
import { StatusLabel } from '../components/StatusLabel';

interface SectionTitleProps {
	title: string;
	TitleIcon?: LucideIcon;
	actions?: ReactNode;
	status?: string | ReactNode;
	description?: string;
}

export function SectionTitle({ title, TitleIcon, actions, status, description }: SectionTitleProps) {
	const statusElement = status ? typeof status === 'string' ? <StatusLabel status={status} /> : status : null;
	return (
		<div className="flex items-center justify-between border-b border-gray-100 bg-gray-50/60 px-5 py-3.5">
			<div className="flex flex-col">
				<div className="flex items-center gap-4">
					{!TitleIcon ? (
						<h3 className="text-sm font-semibold text-gray-800">{title}</h3>
					) : (
						<div className="flex items-center gap-2">
							<TitleIcon className="size-5 text-primary-500" />
							<h3 className="text-sm font-semibold text-gray-800">{title}</h3>
						</div>
					)}
					{statusElement}
				</div>

				{description && <span className="mt-1 text-sm text-gray-500">{description}</span>}
			</div>
			{actions && <div className="flex items-center gap-1.5">{actions}</div>}
		</div>
	);
}
